import * as React from 'react';
import {useCallback} from 'react';
import ConnectedUploadImageStatusBar from '../../../shared/components/ConnectedUploadImageStatusBar';
import PhotosPicker from '../../../shared/components/PhotosPicker';
import {ExtendedWrappedFieldProps} from '../FormFields';

export type FormPhotosProps = ExtendedWrappedFieldProps & {resourceType: string};
const FormPhotos: React.FunctionComponent<FormPhotosProps> = ({
  instructionText,
  explanationText,
  label,
  input: {onChange, value},
  showErrors,
  meta,
  ...props
}) => {
  const handleChange = useCallback(
    value => {
      onChange(value);
    },
    [onChange]
  );
  return (
    <React.Fragment>
      <PhotosPicker updatePicturesURLs={handleChange} picturesURLs={value} buttonLabel="upload photos" {...props} />
      <ConnectedUploadImageStatusBar resourceType={props.resourceType} />
    </React.Fragment>
  );
};

export default FormPhotos;
